module.exports = "https://cdn.thelire.com/ins/resource/lucky-coins-main-pic.fc527529e260a40941f9f9140bfca1bc.png";